import React, { useState } from "react";
import { emailValidation, notEmptyValidation, urlValidation } from "../../../functions/validations";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const InputPassword = (props) => {
  const { placeholder, value, onChange, name, validation, errorText, size, className } = props;

  const [error, seterror] = useState(null);
  const [passwordVisible, setpasswordVisible] = useState(false);

  function checkValidation() {
    if (validation === "ne") {
      !notEmptyValidation(value) && seterror(errorText ? errorText : "Required Input");
    } else if (validation === "email") {
      !emailValidation(value) && seterror(errorText ? errorText : "Invalid E-mail Address");
    } else if (validation === "url") {
      !urlValidation(value) && seterror(errorText ? errorText : "Invalid URL");
    } else {
      seterror(null);
    }
  }

  return (
    <div className={`input-text ${size} ${error ? "input-error" : ""} ${className}`}>
      <p className="label">{error ? error : placeholder}</p>
      <div className="input">
        <input
          type={!passwordVisible ? "password" : "text"}
          placeholder={error ? error : placeholder}
          value={value}
          onChange={(e) => {
            seterror(null);
            onChange(e);
          }}
          name={name}
          //   onBlur={checkValidation}
        />
        {passwordVisible ? (
          <VisibilityOffIcon onClick={() => setpasswordVisible(false)} />
        ) : (
          <VisibilityIcon onClick={() => setpasswordVisible(true)} />
        )}
      </div>
    </div>
  );
};

export default InputPassword;
